import { multiselectQuestions, quantityQuestions } from './constants';
import { QuestionSettingsHook } from './types';

export const useQuestionSettings = (): QuestionSettingsHook => ({
  isMultiselect: (questionCode) => multiselectQuestions.includes(questionCode),
  isQuantityEnabled: (questionCode) => quantityQuestions.includes(questionCode),
});
